import * as React from "react";
import { Button, ClickAwayListener, styled, Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";
import { useCallback, useState } from "react";
import { useTranslate } from "../../../hooks/useTranslate";

//region [[ Styles ]]

const DemoPanelTooltipView = styled("div")({});

export const DemoBadge = styled(Button)({
  "&.demo-badge, &.demo-badge:hover, &.demo-badge:active, &.demo-badge:focus": {
    backgroundColor: "#FEB700",
    color: "#8E6600",
    borderRadius: "6px",
    padding: "6px 10px",
    margin: "7px 0",
    fontSize: "10px",
    lineHeight: "10px",
    fontWeight: 700,
    textTransform: "none",
  },
});

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    padding: "14px 22px",
    fontWeight: 700,
    fontSize: "12px",
    boxShadow: "0px 7px 17px 0px rgba(0, 0, 0, 0.05)",
    border: "1px solid #dadde9",
  },
}))(Tooltip);
//endregion [[ Styles ]]

//region [[ Props ]]

export interface DemoPanelTooltipProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DemoPanelTooltip = ({ ...props }: DemoPanelTooltipProps) => {
  const [open, setOpen] = useState(false);

  const { translate } = useTranslate();

  const handleTooltipClose = useCallback(() => setOpen(false), [setOpen]);

  const handleShowTooltip = useCallback(() => setOpen(true), [setOpen]);

  return (
    <DemoPanelTooltipView>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <HtmlTooltip
            PopperProps={{
              disablePortal: true,
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={<>{translate("DEMO_DISCLAIMER")}</>}
          >
            <DemoBadge className={"demo-badge"} onClick={handleShowTooltip}>
              {translate("DEMO_MODE")}
            </DemoBadge>
          </HtmlTooltip>
        </div>
      </ClickAwayListener>
    </DemoPanelTooltipView>
  );
};
